var staticStrUndefined = require('./staticStrUndefined')

/* eslint-disable valid-typeof */
var staticWindow = typeof window === staticStrUndefined ? 0 : window

module.exports = staticWindow



//////////////////
// WEBPACK FOOTER
// ./~/xe-utils/staticWindow.js
// module id = q0zn
// module chunks = 141